import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Button } from "@/components/Elements/Button";
import { Head } from "@/components/Elements/Head";
import { Icon } from "@/components/Elements/Icon";
import "./Error.scss";
import { analyticsEvent } from "@/utils/Analytics";

const supportEmail = "support@magazinediscountcenter.com";

export const Error = () => {
	const navigate = useNavigate();
	const { state } = useLocation();
	const { errors } = state || "";

	useEffect(() => {
		if (errors) {
			console.error("Error: ", errors);
			analyticsEvent({ action: "UX Impact", category: "MDC Error", label: errors });
		}
	}, [errors]);

	return (
		<>
			<Head title="Error" />
			<section className="error row" aria-label="Error">
				<div className="error__content">
					<div className="error__header">
						<div className="error__title">
							<Icon icon="mdc-logo-img" className="error__logo" label="MDC Error Page" />
							<h1 className="txt-title-xxl error__404 text-center">Oops! 404</h1>
							<p className="txt-title-md text-center">
								We&apos;re sorry, but it seems like the page you were looking for is no longer
								available
							</p>
						</div>
						<p className="txt-md">
							The magazine you were seeking might have flown off our shelves or taken a temporary
							break. Our team of enthusiastic readers is constantly updating our collection with
							fresh and exciting magazines, so there&apos;s always something new to discover.
						</p>
					</div>
					<div className="error__instructions">
						<p className="txt-title-md">Here are a few things you can try:</p>
						<ol className="pl-4">
							<li>
								<p>
									Browse Our Latest Magazines: Head back to our homepage and explore the wide range
									of captivating magazines we currently offer. From fashion to technology, from
									travel to cooking, there&apos;s something for every interest!
								</p>
							</li>
							<li>
								<p>
									Use the Search Bar: If you know the specific magazine you were looking for, type
									its name into our search bar at the top of the page. It might just pop up and
									surprise you!
								</p>
							</li>
							<li>
								<p>
									Contact Our Support Team: If you believe there&apos;s an issue with our website or
									if you need assistance finding a particular magazine, our friendly support team is
									here to help. Reach out to us via{" "}
									<a className="error__underline" href={`mailto:${supportEmail}`}>
										{supportEmail}
									</a>{" "}
									or call us at [<a href={`tel:18556244517`}>1-855-624-4517</a>].
								</p>
							</li>
						</ol>
					</div>
					<div className="error__note">
						<p className="txt-md">
							In the meantime, we apologize for any inconvenience this may have caused. Feel free to
							explore the rest of our website and immerse yourself in the wonderful world of
							magazines. We&apos;re sure you&apos;ll find something that piques your interest!
						</p>
					</div>
					<div className="error__link-container">
						<h2>Happy reading!</h2>
						<Button
							size="lg"
							variant="secondary"
							className="error__btn"
							onClick={() => navigate("/")}
						>
							Go back home
						</Button>
					</div>
				</div>
			</section>
		</>
	);
};
